// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Andorra */
const AD = /^(?:690\d{6}|[356]\d{5})$/;

export default AD;
